import { INamedItem, NamedItemKeys } from '../../../../spacesPlatform/models/resourceParts';

export interface IGroup extends INamedItem {
  // id: string; // INamedItem
  // name: string; // INamedItem
  userCount?: number;
  isAllUsersGroup: boolean;
  domainName?: string;
  groupLuid?: string;
}

export let LocalGroupDomainName = 'local';

export let GroupKeys = NamedItemKeys;
